import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { Dialog } from '@root/shared/ui-kit'

import { type TransferFlowReatom } from '../../../atoms'

import { TransferProgress } from './transfer-progress'
import { TransferReviewContent } from './transfer-review-content'

import type { DialogProps } from '@root/shared/ui-kit'

type TransferReviewModalProps = {
  model: TransferFlowReatom
  onDone?: () => void
} & Pick<DialogProps, 'onOpenChange' | 'open'>

export const TransferReviewModal: React.FC<TransferReviewModalProps> = ({
  open,
  onOpenChange,
  model,
  onDone,
}) => {
  const { t } = useTranslation()
  const [state] = useAtom(model.transferStateAtom)
  const resetTransferState = useAction(model.transferStateAtom.reset)

  const onOpenChange_ = (open: boolean) => {
    onOpenChange?.(open)

    resetTransferState()

    if (AsyncStateN.isSuccess(state)) {
      onDone?.()
    }
  }

  const renderContent = () => {
    if (AsyncStateN.isReady(state)) {
      return (
        <TransferProgress
          onContinue={() => {
            onOpenChange_(false)
          }}
          onClose={() => {
            onOpenChange_(false)
          }}
          state={state}
        />
      )
    }

    return <TransferReviewContent model={model} />
  }

  return (
    <Root
      variant="functional"
      open={open}
      describedBy={t('transfer')}
      onOpenChange={(open) => {
        onOpenChange_(open)
      }}
    >
      <Dialog.Header title={t('transfer')} />

      <Content>{renderContent()}</Content>
    </Root>
  )
}

const Root = styled(Dialog)`
  width: 400px;
`

const Content = styled.div`
  padding: 8px;

  display: grid;
`
